// Import polyfill from node_modules
// import 'core-js/modules/es6.set.js'
// import 'core-js/modules/es6.array.find-index.js'

(function() {
	var win = $(window),
		ww = win.innerWidth(),
		wh = win.innerHeight(),
		window_width = win.width(),
		ws = win.scrollTop();
	var resizeWindow = function(){
		ww = win.innerWidth();
		wh = win.innerHeight();
	}
	$(window)
		.on('load', function () {
			IndexScroll();
		})
		.on('scroll', function () {
			setTimeout(() => {
				IndexScroll();
			}, 0);
		})
		.on('resize', function () {
			IndexScroll();
		});
	// -----------------------------------
	// 頁面滾動時的動畫判斷
	// -----------------------------------
	function IndexScroll(){
		// 頁面滾動時的動畫判斷
		var $animation_elements = $('.js-animate');
		var window_height = win.height();
		var window_top_position = win.scrollTop();
		var window_bottom_position = (window_top_position + window_height);

		$.each($animation_elements, function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height + (element_height / 3));

			//check to see if this current container is within viewport
			if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
				$element.addClass('hover');
			}else{
				$element.removeClass('hover');
			}
		});
	}

})();



